import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

export interface TicketAssignData {
  folio: string;
  subject: string;
  assignedTo: string | null;
  /** Solo usuarios con rol Administrador Epione. */
  assignees: { id: string; name: string }[];
}

/** Resultado: id del responsable, `null` para quitarlo; `undefined` = cancelar. */
export type TicketAssignResult = { assignedTo: string | null };

/**
 * Asignar responsable a un ticket (acción exclusiva del Administrador Epione).
 * La lista solo trae usuarios con ese rol; el API vuelve a validarlo.
 */
@Component({
  selector: 'app-ticket-assign-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatSelectModule, MatIconModule],
  template: `
<h2 mat-dialog-title>Asignar responsable</h2>
<mat-dialog-content>
  <p class="ctx"><b>{{ data.folio }}</b> · {{ data.subject }}</p>
  @if (data.assignees.length === 0) {
    <p class="empty"><mat-icon>info</mat-icon> No hay usuarios con rol Administrador Epione.</p>
  } @else {
    <mat-form-field appearance="outline" class="full">
      <mat-label>Responsable (Administrador Epione)</mat-label>
      <mat-select [(ngModel)]="selected">
        @for (p of data.assignees; track p.id) {
          <mat-option [value]="p.id">{{ p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.assignedTo) {
    <button mat-button color="warn" (click)="ref.close({ assignedTo: null })">Quitar responsable</button>
  }
  <button mat-stroked-button mat-dialog-close>Cancelar</button>
  <button mat-flat-button color="primary" [disabled]="!selected || selected === data.assignedTo" (click)="ref.close({ assignedTo: selected })">
    <mat-icon>person_add</mat-icon> Asignar
  </button>
</mat-dialog-actions>`,
  styles: [`
    .ctx { margin: 0 0 12px; color: #4b5563; }
    .full { width: 100%; min-width: 320px; }
    .empty { display: flex; align-items: center; gap: 8px; color: #6b7280; }
  `],
})
export class TicketAssignDialogComponent {
  selected: string | null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TicketAssignData,
    public ref: MatDialogRef<TicketAssignDialogComponent, TicketAssignResult>,
  ) {
    this.selected = data.assignedTo ?? null;
  }
}
